import React, { useEffect, useState } from "react";

import styled from "styled-components";

import Modal from "react-modal";

import CancelIcon from "../../../assets/cancel_icon.svg";
import { Circles } from "react-loader-spinner";

import {confirmSavedPaymentMethod} from '../../../utils/backendUtils';

const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  color: #FFFFFF;
`

const ActionButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  width: 100%;
  margin-top: 50px;
  background: #FFFFFF;
  cursor: pointer;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const InfoSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(255, 255, 255, 1);
`


export default function Web2CardAfterComponent(props){
    
    let modalWidth = "446px";
    let modalHeight = "250px";

    const  [success, setSuccess] = useState(false)
    const [error, setError] = useState('');

    const checkPaymentReality = async ()=>{
        let resp = await confirmSavedPaymentMethod();
        if(!resp){
            setError('Failed')
            return
        }
        if(!resp.success){
            setError(resp.message);
            return;
        }
        if(resp.success){
            setSuccess(true);
        }
    }
    useEffect(()=>{
        checkPaymentReality();
    },[]);
    
    
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
		}
	    }}
	>
            {(success && !error) && (
                <div style={{
	            display: 'flex',
	            flexDirection: 'column',
	            position: 'relative',
	            alignItems: 'center'}}>
                    <img onClick={()=>{props.handleModalCloseEvent()}}
	                 src={CancelIcon}
	                 style={{
	                     position: "absolute", opacity: 0.4,
	                     height: 14, width:14,
		             right:10, cursor:"pointer",
		             zIndex:10
		         }}
	            />
                    <HeaderSpan style={{marginTop:20}}>
                        Congrats Card Added!
                    </HeaderSpan>
                    <ActionButtonDiv onClick={()=>{
                        props.handleModalCloseEvent()}}>
                        <ActionButtonTextSpan>
                            Start bidding
                        </ActionButtonTextSpan>
                    </ActionButtonDiv>
                </div>
            )}
            {(!success && !error) && (
                <div style={{
	            display: 'flex',
	            flexDirection: 'column',
	            position: 'relative',
	            alignItems: 'center'}}>
                    <img onClick={()=>{props.handleModalCloseEvent()}}
	                 src={CancelIcon}
	                 style={{
	                     position: "absolute", opacity: 0.4,
	                     height: 14, width:14,
		             right:10, cursor:"pointer",
		             zIndex:10
		         }}
	            />
                    <HeaderSpan style={{marginTop:20}}>
                        Confirming..
                    </HeaderSpan>

                    <InfoSpan style={{marginTop:20, marginBottom:20}}>
                        We will cut 1$ and then refund to confirm.<br/>
                        Please wait
                    </InfoSpan>
                    <div>
                        <Circles ariaLabel="loading-indicator"
                                 color={'white'} 
	                         height={40} 
	                         width={40} 
                        />
                    </div>
                </div>
            )}
            {(error) && (
                <div style={{
	            display: 'flex',
	            flexDirection: 'column',
	            position: 'relative',
	            alignItems: 'center'}}>
                    <img onClick={()=>{props.handleModalCloseEvent()}}
	                 src={CancelIcon}
	                 style={{
	                     position: "absolute", opacity: 0.4,
	                     height: 14, width:14,
		             right:10, cursor:"pointer",
		             zIndex:10
		         }}
	            />
                    <HeaderSpan style={{marginTop:20}}>Failed
                    </HeaderSpan>
                    <InfoSpan style={{marginTop:20, marginBottom:20}}>
                        Please try with another card.<br/>
                        This card seems to not allow future payments
                    </InfoSpan>
                </div>
            )}
        </Modal>
    );
}
